import CourseService from "../Course/Course.service";
export const SCHEDULABLE_TYPE = "Course Group";
export default class SchedulerCourseGroupService {
    static getSchedulableSet(group, courses) {
        return {
            id: group.id,
            type: SCHEDULABLE_TYPE,
            children: courses.map((course) => 
            // @ts-expect-error - TS2345 - Argument of type 'import("/Users/dkrajnak/workspace/aviso/sse-frontend/react/src/Domain/Course.model").Course' is not assignable to parameter of type 'import("/Users/dkrajnak/workspace/aviso/sse-frontend/react/src/Domain/Course/Course.model").Course'.
            CourseService.getSchedulableSet(course.course, course.sections)),
        };
    }
}
